import { Component, Output, EventEmitter } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'question-button',
  templateUrl: 'question-button.component.html',
  styleUrls: ['question-button.component.scss'],
})
export class QuestionButtonComponent {}
